var AdPosition = require('./constants/adPosition')
var Adapter = require('./constants/adapter')
var ManifestError = require('./constants/manifestError')
var RequestMethod = require('./constants/requestMethod')
var Service = require('./constants/service')
var WillSendEvent = require('./constants/willSendEvent')
var WillSendLog = require('./constants/willSendLog')
var AdInsertionType = require('./constants/adInsertionType')
/**
 * This static class englobes npaw constants.
 *
 * @class
 * @static
 * @memberof npaw
 */
var Constants = {
  AdPosition: AdPosition,
  ManifestError: ManifestError,
  RequestMethod: RequestMethod,
  Service: Service,
  WillSendEvent: WillSendEvent,
  WillSendLog: WillSendLog,
  AdInsertionType: AdInsertionType,
  Adapter: Adapter
}

module.exports = Constants
